// extracted by mini-css-extract-plugin
export default {"container":"FoldedComments-module__container--bGAZA","folded":"FoldedComments-module__folded--QFHUA","link":"FoldedComments-module__link--xAIuS"};